/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { NftMintTransaction } from './NftMintTransaction';
import {
    NftMintTransactionFromJSON,
    NftMintTransactionFromJSONTyped,
    NftMintTransactionToJSON,
    NftMintTransactionToJSONTyped,
} from './NftMintTransaction';

/**
 * 
 * @export
 * @interface GetNftMintTransactionsResponse
 */
export interface GetNftMintTransactionsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetNftMintTransactionsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<NftMintTransaction>}
     * @memberof GetNftMintTransactionsResponse
     */
    nftMintTransactions: Array<NftMintTransaction>;
}

/**
 * Check if a given object implements the GetNftMintTransactionsResponse interface.
 */
export function instanceOfGetNftMintTransactionsResponse(value: object): value is GetNftMintTransactionsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('nftMintTransactions' in value) || value['nftMintTransactions'] === undefined) return false;
    return true;
}

export function GetNftMintTransactionsResponseFromJSON(json: any): GetNftMintTransactionsResponse {
    return GetNftMintTransactionsResponseFromJSONTyped(json, false);
}

export function GetNftMintTransactionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftMintTransactionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'nftMintTransactions': ((json['nftMintTransactions'] as Array<any>).map(NftMintTransactionFromJSON)),
    };
}

export function GetNftMintTransactionsResponseToJSON(json: any): GetNftMintTransactionsResponse {
    return GetNftMintTransactionsResponseToJSONTyped(json, false);
}

export function GetNftMintTransactionsResponseToJSONTyped(value?: GetNftMintTransactionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'nftMintTransactions': ((value['nftMintTransactions'] as Array<any>).map(NftMintTransactionToJSON)),
    };
}

